import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('handheld', true, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: props.strokeLinejoin
  }, /*#__PURE__*/React.createElement("polyline", {
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    points: "42 18 42 44 6 44 6 18 6 18"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    fill: props.colors[1],
    fillRule: "nonzero",
    x: "6",
    y: "4",
    width: "36",
    height: "14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,27 L16,35",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,31 L20,31",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    fill: props.colors[1],
    fillRule: "nonzero",
    cx: "32",
    cy: "31",
    r: "4"
  })));
});